import React, { useState } from "react";
import { colorMain } from "../../constants/themes";

const Truncate = ({ text, maxLength, lines = 3, children, isRichText }) => {
  const [isTruncated, setIsTruncated] = useState(true);

  const toggleTruncate = () => {
    setIsTruncated(!isTruncated);
  };

  if (isRichText) {
    // For rich text, determine if it needs truncation by raw string word count
    const words = typeof text === "string" ? text.split(" ") : [];
    const needsTruncation = words.length > maxLength;

    const clampStyle = {
      display: "-webkit-box",
      WebkitLineClamp: lines,
      WebkitBoxOrient: "vertical",
      overflow: "hidden",
    };

    return (
      <div>
        <div style={isTruncated && needsTruncation ? clampStyle : {}}>
          {children}
        </div>
        {needsTruncation && (
          <button
            onClick={toggleTruncate}
            style={{
              color: colorMain,
              fontWeight: "bold",
              background: "none",
              border: "none",
              cursor: "pointer",
              padding: 0,
              marginTop: "4px",
            }}
          >
            {isTruncated ? "Read More" : "...Read Less"}
          </button>
        )}
      </div>
    );
  }

  // Original plain text logic fallback
  const words = text?.split(" ");
  if (words?.length <= maxLength && isTruncated) {
    return <p>{text}</p>;
  }
  
  const truncatedText = isTruncated
    ? words?.slice(0, maxLength).join(" ") + "..."
    : text;

  return (
    <div>
      {truncatedText}
      {words?.length > maxLength && (
        <button
          onClick={toggleTruncate}
          style={{
            color: colorMain,
            fontWeight: "bold",
            background: "none",
            border: "none",
            cursor: "pointer",
            padding: 0,
            marginLeft: isTruncated ? "0px" : "4px",
          }}
        >
          {isTruncated ? "Read More" : "...Read Less"}
        </button>
      )}
    </div>
  );
};

export default Truncate;
